export default __webpack_public_path__ + "static/media/team21.ca5da8a8.JPG";